import { getAllInformation, paperCreateByChapter, paperRedo,quesAnaly } from '@api'

export default {
  state: {
    commonInfo: {},
    quesTypeShowMap: [],
    quesShowList: [],
    userAnsMap: [],
    questions: [],
    submitData: [],
    currentQuestion: {},
    currentQuestionType: 0,
    currentQuestionIndex: 0,
    visibleCalc: false,
    isfromTishuashua: false,
  },
  mutations: {
    SET_IS_FROM_TISHUASHUA: (state, data) => {
      state.isfromTishuashua = data
    },
    //设置commonInfo
    SET_COMMON_INFO: (state, data) => {
      state.commonInfo = Object.assign({},data)
      state.commonInfo.statVer++
    },
    //设置quesTypeShowMap
    SET_QUES_TYPE_SHOW_MAP: (state, data) => {
      state.quesTypeShowMap = data
    },
    //设置quesShowList
    SET_QUES_SHOW_LIST: (state, data) => {
      state.quesShowList = data
    },
    //设置userAnsMap
    SET_USER_ANS_MAP: (state, data) => {
      state.userAnsMap = data
    },
    //设置全局questions对象，包含大题，小题，答案等信息。主要的操作模型
    SET_QUESTIONS: (state, data) => {
      state.questions = data
    },
    //设置提交数据
    SET_SUBMIT_DATA: (state, data) => {
      state.submitData = data
    },
    //设置当前题目（小题）
    SET_CURRENT_QUESTION: (state, data) => {
      state.currentQuestion = data
    },
    //设置当前题目用户的答案
    SET_USER_ANSWER: (state, data) => {
      state.currentQuestion.userAnswer = data
    },
    //设置当前题目是否有临时答案
    SET_TEMP_ANSWER: (state, data) => {
      state.currentQuestion.tempAnswer = data
    },
    //设置当前题目预设答案
    SET_ATT_ANSWER: (state, data) => {
      state.currentQuestion.attAnswer = data
    },
    //设置当前题目是否被用户标记
    SET_IS_MARK: (state) => {
      state.currentQuestion.isMark = !state.currentQuestion.isMark ? 1 : 0
    },
    //设置当前题目是否被用户回答
    SET_IS_ANSWER: (state, status) => {
      state.currentQuestion.isAnswer = status
    },
    //设置当前题目是否被用户回答
    SET_ATT_IS_ANSWER: (state, data) => {
      state.currentQuestion.smallContent[data.index].isAnswer = data.isAnswer
    },
    //设置当前复杂题型的子题目用户答案
    SET_SHORT_ANSWER: (state, data) => {
      state.currentQuestion.smallContent[data.index].userAnswer = data.userAnswer
    },
    //设置当前复杂题型的子题目是否有临时答案
    SET_SHORT_TEMP_ANSWER: (state, data) => {
      state.currentQuestion.smallContent[data.index].tempAnswer = data.tempAnswer
    },
    //设置当前复杂题型的子题目预设答案
    SET_SHORT_ATT_ANSWER: (state, data) => {
      state.currentQuestion.smallContent[data.index].attAnswer = data.attAnswer
    },
    //设置当前题目大题类型，1，2，3，4，5
    SET_CURRENT_QUESTION_TYPE: (state, quesType) => {
      state.currentQuestionType = quesType
    },
    //设置当前题目序列号
    SET_CURRENT_QUESTION_INDEX: (state, quesIndex) => {
      state.currentQuestionIndex = quesIndex
    },
    TOGGLE_CALC: (state) => {
      state.visibleCalc = !state.visibleCalc
    }
  },
  actions: {
    getQuesAnaly:({commit},data) =>{
      return new Promise((resolve, reject) => {
        quesAnaly(data).then(res => {
          const { commonInfo, quesTypeShowMap, quesShowList, userAnsMap,questionMap } = res
          commit('SET_COMMON_INFO', commonInfo)
          commit('SET_QUES_SHOW_LIST', quesShowList)
          commit('SET_USER_ANS_MAP', userAnsMap)
          commit('SET_QUES_TYPE_SHOW_MAP', quesTypeShowMap)
          commit('SET_QUESTIONS', questionMap)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getAllInformation: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        getAllInformation(data).then(res => {
          const { commonInfo, quesTypeShowMap, quesShowList, userAnsMap, questionMap, submitData } = res
          commit('SET_COMMON_INFO', commonInfo)
          commit('SET_QUES_SHOW_LIST', quesShowList)
          commit('SET_USER_ANS_MAP', userAnsMap)
          commit('SET_SUBMIT_DATA', submitData)
          commit('SET_QUES_TYPE_SHOW_MAP', quesTypeShowMap)
          commit('SET_CURRENT_QUESTION_TYPE', questionMap[0].quesTypeID - 1)
          commit('SET_CURRENT_QUESTION_TYPE', 0)
          commit('SET_CURRENT_QUESTION_INDEX', 0)
          commit('SET_QUESTIONS', questionMap)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getAllInformationChapter: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        paperCreateByChapter(data).then(res => {
          const { commonInfo, quesTypeShowMap, quesShowList, userAnsMap, questionMap, submitData } = res
          commit('SET_COMMON_INFO', commonInfo)
          commit('SET_QUES_SHOW_LIST', quesShowList)
          commit('SET_USER_ANS_MAP', userAnsMap)
          commit('SET_SUBMIT_DATA', submitData)
          commit('SET_QUES_TYPE_SHOW_MAP', quesTypeShowMap)
          commit('SET_CURRENT_QUESTION_TYPE', questionMap[0].quesTypeID - 1)
          commit('SET_CURRENT_QUESTION_TYPE', 0)
          commit('SET_CURRENT_QUESTION_INDEX', 0)
          commit('SET_QUESTIONS', questionMap)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getAllInformationRedo: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        paperRedo(data).then(res => {
          const { commonInfo, quesTypeShowMap, quesShowList, userAnsMap, questionMap, submitData } = res
          commit('SET_COMMON_INFO', commonInfo)
          commit('SET_QUES_SHOW_LIST', quesShowList)
          commit('SET_USER_ANS_MAP', userAnsMap)
          commit('SET_SUBMIT_DATA', submitData)
          commit('SET_QUES_TYPE_SHOW_MAP', quesTypeShowMap)
          commit('SET_CURRENT_QUESTION_TYPE', questionMap[0].quesTypeID - 1)
          commit('SET_CURRENT_QUESTION_TYPE', 0)
          commit('SET_CURRENT_QUESTION_INDEX', 0)
          commit('SET_QUESTIONS', questionMap)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    setCurQues: ({ commit }, ques) => {
      commit('SET_CURRENT_QUESTION', ques)
    },
    setTempAns: ({ commit }, content) => {
      commit('SET_TEMP_ANSWER', content)
    },
    setAttAns: ({ commit }, content) => {
      commit('SET_ATT_ANSWER', content)
    },
    setUserAns: ({ commit }, content) => {
      commit('SET_USER_ANSWER', content)
    },
    setIsMark: ({ commit }) => {
      commit('SET_IS_MARK')
    },
    setIsAns: ({ commit }, status) => {
      commit('SET_IS_ANSWER', status)
    },
    setAttIsAns: ({ commit }, status) => {
      commit('SET_ATT_IS_ANSWER', status)
    },
    setShortAttAns: ({ commit }, data) => {
      commit('SET_SHORT_ATT_ANSWER', data)
    },
    setShortTempAns: ({ commit }, data) => {
      commit('SET_SHORT_TEMP_ANSWER', data)
    },
    setShortAns: ({ commit }, data) => {
      commit('SET_SHORT_ANSWER', data)
    },
    toggleCalc: ({ commit }) => {
      commit('TOGGLE_CALC')
    },
    setCurQuesType: ({ commit }, type) => {
      commit('SET_CURRENT_QUESTION_TYPE', type)
    },
    setCurQuesIndex: ({ commit }, index) => {
      commit('SET_CURRENT_QUESTION_INDEX', index)
    }
  }
}
